export default "__VITE_ASSET__D4Fhidf5__"